import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import LeasingCommissionItemComponent from './LeasingCommissionItemComponent';
import { useMutation } from 'hooks/apollo';
import { DELETE_LEASING_COMMISSION } from '../mutations';

const LeasingCommissionListContainer = ({ data }) => {
  const [deleteLeasingCommission] = useMutation(DELETE_LEASING_COMMISSION);

  const handleItemsChanged = useCallback(
    commissionId => {
      deleteLeasingCommission({ variables: { input: { commissionId: commissionId } } });
    },
    [deleteLeasingCommission]
  );

  return <LeasingCommissionItemComponent data={data} onItemsChanged={handleItemsChanged} />;
};

LeasingCommissionListContainer.propTypes = {
  data: PropTypes.object
};

export default LeasingCommissionListContainer;
